/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { ArrowDownSm } from '@entrata/portals-common/lib/icons'

import styled from '@emotion/styled'


const StyledButton = styled('button')`
  width: 30%;
  height: 100%;
  border: 0;
  border-left: 1px solid ${({ theme }) => theme.gray.medium};
  background: ${({ theme }) => theme.secondary.light};
  color: ${({ theme }) => theme.secondary.base};
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 16px 24px;
  transition: all 400ms ease;
  text-align: left;

  svg {
    margin-left: 8px;
    transition: transform 300ms ease;
  }

  &:focus,
  &.active {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    outline: none;
  }

  &.active {
    background: white;

    svg {
      transform: rotate(180deg);
    }
  }
`

const NavSelectTrigger = ({ children, ...props }) => (
  <StyledButton {...props}>
    {children || 'More'}
    <ArrowDownSm size={14} />
  </StyledButton>
)

NavSelectTrigger.propTypes = {
  children: PropTypes.any,
}

export default NavSelectTrigger
